export const language = {
  "1": "中文",
  "2": "英语",
  "3": "法语",
  "4": "德语",
  "5": "日语",
  "6": "意大利语",
  "7": "西班牙语",
  "8": "阿萨姆语",
  "9": "艾马拉语",
  "10": "班巴拉语",
  "11": "波斯尼亚语",
  "12": "缅甸语",
  "13": "克罗地亚语",
  "14": "古吉拉特语",
  "15": "海地克里奥尔语",
  "16": "豪萨语",
  "17": "印尼语",
  "18": "爪哇语",
  "19": "卡纳达语",
  "20": "朝鲜语",
  "21": "老挝语",
  "22": "马来语",
  "23": "蒙古语",
  "24": "四川彝语",
  "25": "普什图语",
  "26": "旁遮普语",
  "27": "僧伽罗语",
  "28": "索马里语",
  "29": "塔加洛语",
  "30": "塔吉克语",
  "31": "泰米尔语",
  "32": "泰语",
  "33": "藏语",
  "34": "乌尔都语",
  "35": "越南语",
  "36": "阿塞拜疆语",
  "37": "阿尔巴尼亚语",
  "38": "阿拉伯语",
  "39": "亚美尼亚语",
  "40": "保加利亚语",
  "41": "格鲁吉亚语",
  "42": "丹麦语",
  "43": "希伯来语",
  "44": "现代希腊语",
  "45": "爱沙尼亚语",
  "46": "冰岛语",
  "47": "拉脱维亚语",
  "48": "立陶宛语",
  "49": "孟加拉语",
  "50": "尼泊尔语",
  "51": "挪威语",
  "52": "荷兰语",
  "53": "匈牙利语",
  "54": "乌克兰语",
  "55": "波斯语",
  "56": "波兰语",
  "57": "葡萄牙语",
  "58": "罗马尼亚语",
  "59": "俄语",
  "60": "梵语",
  "61": "塞尔维亚语",
  "62": "马其顿语",
  "63": "斯洛伐克语",
  "64": "斯洛文尼亚语",
  "65": "斯瓦希里语",
  "66": "瑞典语",
  "67": "泰卢固语",
  "68": "土耳其语",
  "69": "捷克语",
  "70": "芬兰语",
  "71": "印地语",
  "72": "高棉语"
};
export const languageArr = [{
    "language_id": "1",
    "zh": "中文"
  },
  {
    "language_id": "2",
    "zh": "英语"
  },
  {
    "language_id": "3",
    "zh": "法语"
  },
  {
    "language_id": "4",
    "zh": "德语"
  },
  {
    "language_id": "5",
    "zh": "日语"
  },
  {
    "language_id": "6",
    "zh": "意大利语"
  },
  {
    "language_id": "7",
    "zh": "西班牙语"
  },
  {
    "language_id": "8",
    "zh": "阿萨姆语"
  },
  {
    "language_id": "9",
    "zh": "艾马拉语"
  },
  {
    "language_id": "10",
    "zh": "班巴拉语"
  },
  {
    "language_id": "11",
    "zh": "波斯尼亚语"
  },
  {
    "language_id": "12",
    "zh": "缅甸语"
  },
  {
    "language_id": "13",
    "zh": "克罗地亚语"
  },
  {
    "language_id": "14",
    "zh": "古吉拉特语"
  },
  {
    "language_id": "15",
    "zh": "海地克里奥尔语"
  },
  {
    "language_id": "16",
    "zh": "豪萨语"
  },
  {
    "language_id": "17",
    "zh": "印尼语"
  },
  {
    "language_id": "18",
    "zh": "爪哇语"
  },
  {
    "language_id": "19",
    "zh": "卡纳达语"
  },
  {
    "language_id": "20",
    "zh": "朝鲜语"
  },
  {
    "language_id": "21",
    "zh": "老挝语"
  },
  {
    "language_id": "22",
    "zh": "马来语"
  },
  {
    "language_id": "23",
    "zh": "蒙古语"
  },
  {
    "language_id": "24",
    "zh": "四川彝语"
  },
  {
    "language_id": "25",
    "zh": "普什图语"
  },
  {
    "language_id": "26",
    "zh": "旁遮普语"
  },
  {
    "language_id": "27",
    "zh": "僧伽罗语"
  },
  {
    "language_id": "28",
    "zh": "索马里语"
  },
  {
    "language_id": "29",
    "zh": "塔加洛语"
  },
  {
    "language_id": "30",
    "zh": "塔吉克语"
  },
  {
    "language_id": "31",
    "zh": "泰米尔语"
  },
  {
    "language_id": "32",
    "zh": "泰语"
  },
  {
    "language_id": "33",
    "zh": "藏语"
  },
  {
    "language_id": "34",
    "zh": "乌尔都语"
  },
  {
    "language_id": "35",
    "zh": "越南语"
  },
  {
    "language_id": "36",
    "zh": "阿塞拜疆语"
  },
  {
    "language_id": "37",
    "zh": "阿尔巴尼亚语"
  },
  {
    "language_id": "38",
    "zh": "阿拉伯语"
  },
  {
    "language_id": "39",
    "zh": "亚美尼亚语"
  },
  {
    "language_id": "40",
    "zh": "保加利亚语"
  },
  {
    "language_id": "41",
    "zh": "格鲁吉亚语"
  },
  {
    "language_id": "42",
    "zh": "丹麦语"
  },
  {
    "language_id": "43",
    "zh": "希伯来语"
  },
  {
    "language_id": "44",
    "zh": "现代希腊语"
  },
  {
    "language_id": "45",
    "zh": "爱沙尼亚语"
  },
  {
    "language_id": "46",
    "zh": "冰岛语"
  },
  {
    "language_id": "47",
    "zh": "拉脱维亚语"
  },
  {
    "language_id": "48",
    "zh": "立陶宛语"
  },
  {
    "language_id": "49",
    "zh": "孟加拉语"
  },
  {
    "language_id": "50",
    "zh": "尼泊尔语"
  },
  {
    "language_id": "51",
    "zh": "挪威语"
  },
  {
    "language_id": "52",
    "zh": "荷兰语"
  },
  {
    "language_id": "53",
    "zh": "匈牙利语"
  },
  {
    "language_id": "54",
    "zh": "乌克兰语"
  },
  {
    "language_id": "55",
    "zh": "波斯语"
  },
  {
    "language_id": "56",
    "zh": "波兰语"
  },
  {
    "language_id": "57",
    "zh": "葡萄牙语"
  },
  {
    "language_id": "58",
    "zh": "罗马尼亚语"
  },
  {
    "language_id": "59",
    "zh": "俄语"
  },
  {
    "language_id": "60",
    "zh": "梵语"
  },
  {
    "language_id": "61",
    "zh": "塞尔维亚语"
  },
  {
    "language_id": "62",
    "zh": "马其顿语"
  },
  {
    "language_id": "63",
    "zh": "斯洛伐克语"
  },
  {
    "language_id": "64",
    "zh": "斯洛文尼亚语"
  },
  {
    "language_id": "65",
    "zh": "斯瓦希里语"
  },
  {
    "language_id": "66",
    "zh": "瑞典语"
  },
  {
    "language_id": "67",
    "zh": "泰卢固语"
  },
  {
    "language_id": "68",
    "zh": "土耳其语"
  },
  {
    "language_id": "69",
    "zh": "捷克语"
  },
  {
    "language_id": "70",
    "zh": "芬兰语"
  },
  {
    "language_id": "71",
    "zh": "印地语"
  },
  {
    "language_id": "72",
    "zh": "高棉语"
  }
];